import brandPortalAccountRoute from "@faire/web-api/routes/brand-portal/account";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var CANPayoutsIA = function CANPayoutsIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "rcTW0Q",
    defaultMessage: [{
      "type": 0,
      "value": "Om te beginnen met het ontvangen van betalingen moet je een Amerikaans routeringsnummer instellen, zodat je in USD betaald kunt worden via een ACH-storting. Zo werkt dat:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "HC7U/H",
    defaultMessage: [{
      "type": 0,
      "value": "Registreer je voor een account met meerdere valuta’s. We raden je aan "
    }, {
      "children": [{
        "type": 0,
        "value": "OFX"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": " te gebruiken."
    }],
    values: {
      LinkFormatting: OxfLinkFormatting
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "YNvT+t",
    defaultMessage: [{
      "type": 0,
      "value": "Zodra je een routeringsnummer in de VS hebt, ga je naar je "
    }, {
      "children": [{
        "type": 0,
        "value": "Accountinstellingen"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "qfxObM",
    defaultMessage: [{
      "type": 0,
      "value": "Ga naar het tabblad "
    }, {
      "children": [{
        "type": 0,
        "value": "Uitbetalingen"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "payment");
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "sjxp9Z",
    defaultMessage: [{
      "type": 0,
      "value": "Voeg je bankgegevens toe, waaronder: naam rekeninghouder, routeringsnummer en rekeningnummer."
    }]
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "gAWP8i",
    defaultMessage: [{
      "type": 0,
      "value": "Uitbetalingen worden vervolgens verwerkt volgens het uitbetalingsschema dat je hebt gekozen in je accountinstellingen."
    }]
  })));
};
var OxfLinkFormatting = function OxfLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: "https://www.ofx.com/p/faire/?pid=13968",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};